import React from 'react'

import { OrderItem } from '../../Types/OrderItem'

interface DocketItemsProps {
  note: string
  items: OrderItem[]
}

export default function DocketItems({ items, note }: DocketItemsProps) {
  // Sort items outside of the current department to the bottom of the docket
  const sortedItems = items
    ? items.slice().sort((a, b) => Number(b.inThisDepartment) - Number(a.inThisDepartment))
    : []
  return (
    <>
      {note && <p className="production-note">{note}</p>}
      <table className="docket-items" cellSpacing={0}>
        <tbody>
          {sortedItems?.map((item, index) => {
            let itemClasses = ''

            if (!item.inThisDepartment) {
              itemClasses += 'outside-department'
            }

            if (item.packItems && item.packItems.length > 0) {
              itemClasses += ' docket-pack-item'
            }

            return (
              <React.Fragment key={index}>
                <tr key={index} className={itemClasses}>
                  <td className="item-qty">
                    {item.weightType != 'Fixed' ? (
                      <span>
                        {item.quantity} {item.unitType}
                      </span>
                    ) : (
                      <span>{item.quantity} x</span>
                    )}
                  </td>
                  <td className="docket-item">
                    <div>{item.item}</div>
                    {item.notes && <div className="docket-notes">{item.notes}</div>}
                    {item.optionSummary && <div className="docket-notes">{item.optionSummary}</div>}
                  </td>
                </tr>
                {item.packItems &&
                  item.packItems.length > 0 &&
                  item.packItems.map((packItem, index) => (
                    <tr
                      key={`${index}`}
                      className={
                        !packItem.inThisDepartment
                          ? 'docket-pack-sub-item outside-department'
                          : 'docket-pack-sub-item'
                      }
                    >
                      <td className="item-qty">{packItem.quantity} x</td>
                      <td className="docket-item">
                        <div>{packItem.item}</div>
                        {packItem.notes && <div className="docket-notes">{packItem.notes}</div>}
                      </td>
                    </tr>
                  ))}
              </React.Fragment>
            )
          })}
        </tbody>
      </table>
    </>
  )
}
